export default __webpack_public_path__ + "static/media/smallimgicon.6eb58175.png";